module.exports = __webpack_public_path__ + "favicon.ico?69cfec3056e60d5939503ed800f04f17";